import { eq } from "drizzle-orm";
import { Box, Link as MuiLink, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";

import { db } from "@/db/db";
import { link } from "@/db/schema";
import type { Item } from "@/db/types";
import { useReactiveRelationalQuery } from "@/models/hooks/useReactiveRelationalQuery";

const linksQuery = (contentId: string) =>
  db.query.link.findMany({
    where: eq(link.contentId, contentId),
  });

export default function ItemLinksTable({ item }: { item: Item }) {
  const links = useReactiveRelationalQuery(linksQuery, [item.contentId], "ItemLinksTable:findManyLinks") ?? [];

  return (
    <TableContainer>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>URL</TableCell>
            <TableCell>Title</TableCell>
            <TableCell>Description</TableCell>
            <TableCell>Image</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {links.map((row) => (
            <TableRow key={row.id} sx={{ "&:last-child td": { border: 0 } }}>
              <TableCell sx={{ maxWidth: 300 }}>
                <MuiLink
                  href={row.url}
                  target="_blank"
                  rel="noreferrer"
                  sx={{
                    display: "block",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  {row.url}
                </MuiLink>
              </TableCell>
              <TableCell>{row.title}</TableCell>
              <TableCell sx={{ maxWidth: 200 }}>
                <Box sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{row.description}</Box>
              </TableCell>
              <TableCell>
                {row.image && (
                  <MuiLink href={row.image} target="_blank" rel="noreferrer">
                    View
                  </MuiLink>
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
